module.exports = __webpack_public_path__ + "static/media/shower12.61547426.png";